import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./TasksNotification.module.css";

interface TasksNotificationProps {
  isVisible: boolean;
  taskCount: number;
  onClose: () => void;
}

const TasksNotification: React.FC<TasksNotificationProps> = ({
  isVisible,
  taskCount,
  onClose,
}) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={styles.container}
          initial={{ opacity: 0, scale: 0.8, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 10 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 25,
          }}
        >
          <div className={styles.content}>
            <div className={styles.textContainer}>
              <div className={styles.title}>Новые задания!</div>
              <div className={styles.description}>
                Доступно {taskCount}{" "}
                {taskCount === 1
                  ? "задание"
                  : taskCount < 5
                  ? "задания"
                  : "заданий"}
              </div>
            </div>
          </div>
          <div className={styles.arrow}></div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TasksNotification;
